import React from "react";

// Minimal, dependency-free markdown renderer for AI draft content.
function renderInline(text) {
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**") ? (
      <strong key={`b-${i}-${p.slice(2, 14)}`} className="font-semibold text-foreground">{p.slice(2, -2)}</strong>
    ) : (
      <React.Fragment key={`t-${i}-${p.slice(0, 12)}`}>{p}</React.Fragment>
    )
  );
}

export function Markdown({ content, className = "" }) {
  if (!content) return null;
  const lines = String(content).split("\n");
  const blocks = [];
  let list = [];

  const flushList = (key) => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${key}`} className="my-2 ml-5 list-disc space-y-1 text-sm text-foreground/90">
          {list.map((li, i) => <li key={`${key}-${i}-${li.slice(0, 16)}`}>{renderInline(li)}</li>)}
        </ul>
      );
      list = [];
    }
  };

  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (/^#{3}\s/.test(line)) { flushList(idx); blocks.push(<h5 key={idx} className="mt-4 font-heading text-sm font-bold uppercase tracking-wide text-foreground">{renderInline(line.replace(/^#{3}\s/, ""))}</h5>); }
    else if (/^#{2}\s/.test(line)) { flushList(idx); blocks.push(<h4 key={idx} className="mt-4 font-heading text-base font-bold text-foreground">{renderInline(line.replace(/^#{2}\s/, ""))}</h4>); }
    else if (/^#\s/.test(line)) { flushList(idx); blocks.push(<h3 key={idx} className="mt-4 font-heading text-lg font-extrabold text-foreground">{renderInline(line.replace(/^#\s/, ""))}</h3>); }
    else if (/^[-*]\s/.test(line)) { list.push(line.replace(/^[-*]\s/, "")); }
    else if (line.trim() === "") { flushList(idx); }
    else { flushList(idx); blocks.push(<p key={idx} className="my-2 text-sm leading-relaxed text-foreground/90">{renderInline(line)}</p>); }
  });
  flushList("end");

  return <div className={className}>{blocks}</div>;
}
